/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const featureId = feature.getID();
    const TEMPERATURE = feature.getSettingValue('TEMPERATURE');

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    "TEMPERATURE": 0,
});`,
    });

    blocks.push({
        location: `var_${TEMPERATURE}_update`,
        blockType: BlockType.CODE,
        template: `var_${TEMPERATURE}_update_completed(simulator.context["${featureId}"]["TEMPERATURE"]);`,
    });
    return blocks;
};
